export default "__VITE_ASSET__BhMFCu$8__"